module.exports = __webpack_public_path__ + "static/media/EllipseBlue.f0b9e3ec.svg";